import { BaseExportModal } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useMemo } from 'react'
import { REBATE_ENROLLMENT_COLUMNS } from 'features/tradespend/enrollments/rebateEnrollmentsColumnInfo'
import { useDownload } from 'features/download-widget'
import { exportRebateEnrollments } from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

interface EnrollmentExportModalProps {
  show: boolean
  _handleClose: () => void
  filters: Record<string, unknown>
  offerId: number
}

export default function EnrollmentExportModal(
  props: EnrollmentExportModalProps
) {
  const { startDownload } = useDownload()
  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )

  const enrollmentColumnHelper = createExportColumnHelper({
    columns: REBATE_ENROLLMENT_COLUMNS,
  })

  const columns = useMemo(() => {
    return [
      {
        title: 'User Information',
        elements: [
          enrollmentColumnHelper.retrieveColumn('tradespend_user_name'),
          enrollmentColumnHelper.retrieveColumn('tradespend_user_email'),
          enrollmentColumnHelper.retrieveColumn('company_name'),
          enrollmentColumnHelper.retrieveColumn('attribution_code'),
          enrollmentColumnHelper.retrieveColumn('status'),
        ],
      },
      {
        title: 'Claims',
        elements: [
          enrollmentColumnHelper.retrieveColumn('total_claims'),
          enrollmentColumnHelper.retrieveColumn('pending_validation_claims'),
          enrollmentColumnHelper.retrieveColumn('invalid_claims'),
          enrollmentColumnHelper.retrieveColumn('unpaid_valid_claims'),
          enrollmentColumnHelper.retrieveColumn('paid_claims'),
        ],
      },
      {
        title: 'Validated Data',
        elements: [
          enrollmentColumnHelper.retrieveColumn('total_validated_units'),
          enrollmentColumnHelper.retrieveColumn('total_validated_payout'),
          enrollmentColumnHelper.retrieveColumn('created'),
        ],
      },
    ]
  }, [])

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Enrollments...' }],
      initiate: async (signal) => {
        const result = await exportRebateEnrollments(
          props.offerId,
          { selected_columns: selectedCols, export_type: exportType },
          props.filters,
          signal
        )
        return { type: 'blob', blob: result.blob, filename: result.filename }
      },
      label: 'enrollments',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Enrollments Download"
      subTitle="Download up to 10,000 enrollments at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Enrollments"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
